module.exports = __webpack_public_path__ + "img/Swissquote.8c78dc8a.svg";